import classNames from 'classnames';
import Link from 'next/link';
import type { FC } from 'react';

type BasicProps = { name: string; onClick?: () => void; isActive?: boolean };

type Props = { href: string } & BasicProps;

export const CategoryLink: FC<Props> = ({ onClick, href, name, isActive }) => {
  return (
    <Link href={href}>
      <a
        onClick={onClick}
        className={classNames(
          'py-1 px-4 border border-solid border-gray900 rounded-[45px] text-sm h-[30px]',
          { 'border-transparent bg-gray100': isActive },
          'semiLg:hover:border-transparent semiLg:hover:bg-gray100'
        )}
      >
        {name}
      </a>
    </Link>
  );
};
